import React from 'react';
import { useTranslation } from 'react-i18next';
import { PickingStats } from '../../types/metrics';

interface StatItemProps {
  label: string;
  value: string | number;
  unit?: string;
}

const StatItem: React.FC<StatItemProps> = ({ label, value, unit }) => (
  <div className="flex justify-between border-b border-gray-700 py-2">
    <span className="text-sm text-gray-300">{label}</span>
    <span className="font-medium text-white">
      {value}
      {unit && <span className="ml-1 text-sm text-gray-400">{unit}</span>}
    </span>
  </div>
);

interface PickingStatsCardProps {
  data: PickingStats;
}

const PickingStatsCard: React.FC<PickingStatsCardProps> = ({ data }) => {
  const { t } = useTranslation('app');

  return (
    <div className="bg-app-panel-dark rounded-lg p-4">
      <div className="mb-6 border-b border-gray-700 pb-4">
        <h3 className="text-2xl font-bold text-yellow-300">{data.totalTime}</h3>
        <div className="mt-2 flex items-baseline">
          <span className="text-4xl font-bold text-white">
            {data.totalPicks}
          </span>
          <span className="ml-2 text-lg text-gray-400">{t('Total picks')}</span>
        </div>
      </div>

      <div className="space-y-1">
        <StatItem label={t('Picklists')} value={data.picklists} />
        <StatItem label={t('Lines Count')} value={data.linesCount} />
        <StatItem label={t('UOM Count')} value={data.uomCount} />
        <StatItem
          label={t('Pick Rate (NET)')}
          value={data.pickRateNet}
          unit="picks/hr"
        />
        <StatItem
          label={t('Pick Rate (GROSS)')}
          value={data.pickRateGross}
          unit="picks/hr"
        />
        <StatItem
          label={t('UOM Rate (NET)')}
          value={data.uomRateNet}
          unit="units/hr"
        />
        <StatItem
          label={t('UOM Rate (GROSS)')}
          value={data.uomRateGross}
          unit="units/hr"
        />
        <StatItem
          label={t('Avg. Units per Line')}
          value={data.avgUnitsPerLine}
          unit="units/line"
        />
        <StatItem label={t('Net Time')} value={data.netTime} />
        <StatItem label={t('Gross Time')} value={data.grossTime} />
        <StatItem label={t('Idle Time')} value={data.idleTime} />
      </div>
    </div>
  );
};

export default PickingStatsCard;
